import React, { useEffect, useState } from 'react';
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import dayjs from 'dayjs';
import { Doughnut } from 'react-chartjs-2';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';

import services from '@C/Dashboard/Components/Graphs/data';

import './styles.scoped.scss';

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

const barColors = ['#5A89D1', '#D3789E', '#EAAF00', '#72D275', '#A284BA'];

const DashboardGraphs = () => {
  const [date, setDate] = useState(dayjs().format('YYYY-MM-DD'));
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: function (data) {
            return `${data.dataset.label} for ${data.label}: ${data.formattedValue}`;
          },
        },
      },
    },
  };

  useEffect(() => {
    getDSRChartsData();
  }, [date]);

  const getDSRChartsData = () => {
    setLoading(true);
    services
      .getDSRChart(date)
      .then((response) => {
        const labelsData = response.data.data.product_wise.map((item) =>
          item.product === 'Lube' ? 'Products' : item.product,
        );

        const dataSets = [
          {
            label: 'Sales by liters',
            data: response.data.data.product_wise.map((item) =>
              item.total_sale_in_liters.toFixed(2),
            ),
            backgroundColor: barColors.slice(0, labelsData.length),
          },
          {
            label: 'Sales by amount',
            data: response.data.data.product_wise.map((item) =>
              item.total_sale_value.toFixed(2),
            ),
            backgroundColor: barColors.slice(0, labelsData.length),
          },
        ];
        setData({
          labels: labelsData,
          datasets: dataSets,
        });
        setLoading(false);
      })
      .catch((error) => {
        console.log(error.response.data.error);
      });
  };

  if (loading) {
    return <DropLoaderLarge />;
  }

  return (
    <section className="widget">
      <header>
        <div className="stock-info-header">
          <h3> Graphs </h3>
        </div>
        <div className="input-wrapper">
          <input
            className="cstm-date-input"
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </div>
      </header>
      <main>
        <div className="charts-container">
          <div className="chart-item">
            {loading && <DropLoaderLarge />}
            <Doughnut
              options={options}
              data={data}
              height={400}
              datasetIdKey={'label'}
            />
          </div>
        </div>
      </main>
    </section>
  );
};

export { DashboardGraphs };
